var _path, _g, _path2, _g2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_2053)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_282_2053)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_282_2053)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_282_2053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 8,
    width: 14,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 17.7124H25.375V8.43415L12.625 8.43415L12.625 17.7124Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_282_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.472 8.43428H25.2533C25.3643 8.43428 25.4033 8.49953 25.3553 8.60153L20.262 17.6195C20.246 17.6494 20.2217 17.6741 20.1921 17.6906C20.1624 17.7071 20.1287 17.7147 20.0948 17.7125H17.9048C17.8709 17.7147 17.8372 17.7071 17.8075 17.6906C17.7779 17.6741 17.7536 17.6494 17.7375 17.6195L12.6443 8.60153C12.5978 8.49953 12.6353 8.43428 12.7463 8.43428H14.5283C14.5622 8.43203 14.596 8.43961 14.6256 8.45611C14.6553 8.4726 14.6796 8.49732 14.6955 8.52728L18.9998 16.1818L23.3048 8.52728C23.3208 8.49738 23.3451 8.47272 23.3748 8.45623C23.4044 8.43974 23.4382 8.43212 23.472 8.43428Z",
    fill: "#F4F4F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_282_2053",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 20,
    width: 14,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 29.7124H25.375V20.4342H12.625L12.625 29.7124Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_282_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.472 20.4343H25.2533C25.3643 20.4343 25.4033 20.4995 25.3553 20.6015L20.262 29.6195C20.246 29.6494 20.2217 29.6741 20.1921 29.6906C20.1624 29.7071 20.1287 29.7147 20.0948 29.7125H17.9048C17.8709 29.7147 17.8372 29.7071 17.8075 29.6906C17.7779 29.6741 17.7536 29.6494 17.7375 29.6195L12.6443 20.6015C12.5978 20.4995 12.6353 20.4343 12.7463 20.4343H14.5283C14.5622 20.432 14.596 20.4396 14.6256 20.4561C14.6553 20.4726 14.6796 20.4973 14.6955 20.5273L18.9998 28.1818L23.3048 20.5273C23.3208 20.4974 23.3451 20.4727 23.3748 20.4562C23.4044 20.4397 23.4382 20.4321 23.472 20.4343Z",
    fill: "#F4F4F4"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37.0249C28.8376 37.0249 36.8125 29.05 36.8125 19.2124C36.8125 9.37483 28.8376 1.3999 19 1.3999C9.16243 1.3999 1.1875 9.37483 1.1875 19.2124C1.1875 29.05 9.16243 37.0249 19 37.0249Z",
    stroke: "#F4F4F4",
    strokeWidth: 1.875
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 37.5,
    fill: "white",
    transform: "translate(0.25 0.462402)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_282_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 37.5,
    fill: "white",
    transform: "translate(0.25 0.462402)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_282_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 37.5,
    fill: "white",
    transform: "translate(0.25 0.462402)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.a5db9963de81f66d84e0bca2f2c39cd2.svg";
export { ForwardRef as ReactComponent };